import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/versionHistory';

export const updateVersionHistory = createAction(types.UPDATE_VERSION_HISTORY);
export const clearVersionHistory = createAction(types.CLEAR_VERSION_HISTORY);
export const updateVersionHistoryItem = createAction(types.UPDATE_VERSION_HISTORY_ITEM);
export const updateVersionHistoryItemLoadedStatus = createAction(types.UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS);
export const updateVersionHistoryItemSavingStatus = createAction(types.UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS);
export const updateVersionHistoryLatestSavedItem = createAction(types.UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM);
export const setVersionHistoryPendingSavedItem = createAction(types.SET_VERSION_HISTORY_PENDING_SAVED_ITEM);
export const trackVersionHistoryPendingSave = createAction(types.TRACK_VERSION_HISTORY_PENDING_SAVE);
export const confirmVersionHistoryPendingSavedItem = createAction(types.CONFIRM_VERSION_HISTORY_PENDING_SAVED_ITEM);
export const revertVersionHistoryPendingSavedItem = createAction(types.REVERT_VERSION_HISTORY_PENDING_SAVED_ITEM);
